import { memo } from 'react';
import { useSelector } from 'react-redux';

import { UploadsTrackingPanel } from '@air/feature-uploads/ui';

import { useCancelAllPrivateUploads } from '~/components/Upload/hooks/useCancelAllPrivateUploads';
import { usePrivateUploadDelete } from '~/components/Upload/hooks/usePrivateUploadDelete';
import { PrivateUploadManagerRuntime } from '~/components/Upload/PrivateUploadManagerRuntime';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { uploadedDestinationSummarySelector } from '~/store/privateUploadMetadata/selectors';

export const PrivateUploadManager = memo(() => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const { currentWorkspace } = useCurrentWorkspace();

  const { onDeleteUpload } = usePrivateUploadDelete({ analyticsContext: 'private_upload_manager' });
  const { cancelAllUploads: onCancelAllUploads } = useCancelAllPrivateUploads({
    analyticsContext: 'private_upload_manager',
    deleteAllErrorContext: 'Failed to delete all uploads',
  });
  const summaryBoard = useSelector(uploadedDestinationSummarySelector);

  return (
    <>
      <PrivateUploadManagerRuntime />
      {ui2026 ? null : (
        <UploadsTrackingPanel
          isExpanded
          summaryLocation={summaryBoard?.title || currentWorkspace?.name}
          onCancelAllUploads={onCancelAllUploads}
          onDeleteUpload={onDeleteUpload}
        />
      )}
    </>
  );
});

PrivateUploadManager.displayName = 'PrivateUploadManager';
